import { Route } from '@angular/router';

import { MpsIRoutesRules } from '../interfaces/mps-routes-rules.interface';
import { applicationRouteNames } from '../../app/application-route-names';
import { MpsUser } from '../../app/models/mps-user.model';
import { MpsRoleHelper } from '../../app/helpers/mps-role.helper';
import { globalRouteNames } from '../../app/shared/global-route-names';

const MENU_ADMINISTRATION_ROLES = [MpsRoleHelper.ADMIN];

export class MpsPermissionHelper {
  // Use properties 'forbiddenRoles' or 'allowedRoles' to define user page access.
  // Use property 'forbiddenRoles' to deny access to user having those specifics roles :
  // { routepath: routeNames.home, forbiddenRoles: [RoleHelper.PARTNER] },
  // Use property 'allowedRoles' to give access only to user having those specifics roles :
  // { routepath: routeNames.home, allowedRoles: [RoleHelper.OWNER, RoleHelper.ADMIN, RoleHelper.SUPERADMIN] },

  static readonly routesRules: MpsIRoutesRules[] = [
    { routepath: applicationRouteNames.home },
    // Menu entries must use the real route paths ('admin', 'user-management') and the same roles as their guards
    // (administration.guard.ts / user-management.guard.ts), otherwise they are displayed to every user.
    // Both screens are reserved to administrators.
    { routepath: globalRouteNames.admin, allowedRoles: MENU_ADMINISTRATION_ROLES },
    { routepath: globalRouteNames.userManagement, allowedRoles: MENU_ADMINISTRATION_ROLES },
    { routepath: applicationRouteNames.lokalise, allowedRoles: [MpsRoleHelper.ADMIN] },
  ];

  static canUserActivate(user: MpsUser, route: Route) {
    const routeRule = this.routesRules.find((r) => r.routepath === route.path);
    if (routeRule) {
      if (routeRule.forbiddenRoles && routeRule.forbiddenRoles.length > 0) {
        return this.hasNotRole(user, routeRule.forbiddenRoles);
      } else if (routeRule.allowedRoles && routeRule.allowedRoles.length > 0) {
        return this.hasAnyRole(user, routeRule.allowedRoles);
      } else {
        return true;
      }
    }
    return true;
  }

  static isAdmin(user: MpsUser): boolean {
    return user.role !== null && user.isAdmin();
  }

  static hasAnyRole(user: MpsUser, rolesList: string[]) {
    return user.role && rolesList.includes(user.role.code.toUpperCase());
  }

  static hasNotRole(user: MpsUser, rolesList: string[]) {
    return user.role && !rolesList.includes(user.role.code.toUpperCase());
  }
}
